module.exports = __webpack_public_path__ + "cf3929f0bea3e6c7e0af4e2b7ee0b093.svg";